export const labelMap = {
  node_exporter: 'Node Exporter',
  wazuh_agent: 'Wazuh Agent',
  cockpit: 'Cockpit',
  mysql_exporter: 'MySQL Exporter',
  redis_exporter: 'Redis Exporter',
  nginx_exporter: 'Nginx Exporter',
  docker_exporter: 'Docker Exporter',
  gitlab_exporter: 'GitLab Exporter',
  process_exporter: 'Process Exporter',
  php_fpm_exporter: 'PHP-FPM Exporter',
  httpd_exporter: 'Apache HTTPD Exporter',
  smartctl_exporter: 'SMART Exporter',
  clickhouse_exporter: 'ClickHouse Exporter',
};
